import {Component, Input, OnInit, OnDestroy} from '@angular/core';

import {GlobalState} from '../../../global.state';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { config } from '../../../../environments/config';

import { LoginService } from '../../../modules/employee/service/login/login.service';
import { LoginCandidateService } from '../../../modules/employee/service/login-candidate/login-candidate.service';
// import { PagesComponent } from '../../../modules/employee/pages/pages.component';
import { BaMenuService } from '../../services';
import { AccountService } from '../../../modules/employee/service/account/account.service';
import { HasPermissionService } from '../../../modules/employee/service/has-permission/has-permission.service';


@Component({
    selector: 'app-ba-page-top',
    templateUrl: './baPageTop.component.html',
    styleUrls: ['./baPageTop.component.scss']
})
export class BaPageTopComponent implements OnInit, OnDestroy {
    @Input() ImgPerfile: string;

    public popupDialog: boolean;

    public docs_url: string = 'https://docs.luciana.app/';

    public isScrolled: boolean;
    public isMenuCollapsed: boolean;
    public currentLang: string;
    public langs = {
        es: 'Español',
        en: 'English'
    };
    public display: boolean;
    public displayHappyBirthDayDialog: boolean;
    public happyBirthday: boolean;
    public happyBirthdayUsername: string;
    public happyBirthdayTitle: string;
    public happyBirthdayMessage: string;

    public apiUrl = config.API_ROOT;

    public role_id: any = null;
    public synergo_roles = [67, 69, 72, 73];

    public image_route: string;
    public image_url: string;

    constructor(
        private _state: GlobalState,
        public loginService: LoginService,
        public loginCandidateService: LoginCandidateService,
        private translate: TranslateService,
        // public pagesComponent: PagesComponent,
        private _service: BaMenuService,
        private _router: Router,
        private accountService: AccountService,
        public hasPermissionService: HasPermissionService,
        ) {
            this.isScrolled = false;
            this.isMenuCollapsed = false;
            this.currentLang = this.translate.currentLang;
            this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
            this.isMenuCollapsed = isCollapsed;
        });

        this.popupDialog = false;

        this.display = false;
        this.displayHappyBirthDayDialog = false;
        this.happyBirthday = false;
        this.getAccount();
    }

    public ngOnInit(): void {
        this.role_id = JSON.parse(localStorage.getItem('profile')).roles[0].id;

        if(this.synergo_roles.includes(this.role_id)){
            this.image_route = 'assets/images/logos/Logo SynerGo.png';
            this.image_url = 'https://www.synergo.com.co/';
        } else {
            this.image_route = 'assets/images/logos/Logo Redes Humanas.png';
            this.image_url = 'https://redeshumanas.com/';
        }
    }

    public ngOnDestroy(): void {
    }

    public settings () {
        event.preventDefault();

        const profile = JSON.parse(localStorage.getItem('profile'));
        if (profile.employee)
            this._router.navigate(['pages/account']);
        else
            this._router.navigate(['candidate/account']);
    }

    public logout() {
        event.preventDefault();

        const profile = JSON.parse(localStorage.getItem('profile'));

        if (profile.employee_id)
            this.loginService.logout();
        else
            this.loginCandidateService.logoutCandidate();
    }

    // provine for switch language
    // public changeLanguage() {
    //     // this.pagesComponent.changeLanguage(lang);
    // }
    public changeLanguage() {
        event.preventDefault();
        const lang = this.currentLang;
        this.accountService.updateProfile({'language': lang}).toPromise().then(
            response => {
                this.currentLang = lang;
                this.translate.use(this.currentLang);
                // this._service.updateMenuByRoutes(<Routes> this.menu);
            },
            error => {
                console.log(error);
            }
        );
    }
    // provine for languageService
    public languageChaged(lang) {
        this.currentLang = lang;
    }

    public toggleMenu() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
        this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
        return false;
    }

    public scrolledChanged(isScrolled) {
        this.isScrolled = isScrolled;
    }

    showDialog() {
        this.display = true;
    }

    gotoHelp() {
        window.open(this.docs_url, '_blank');
        //   window.open(this.docs_url + '?token=' + localStorage.getItem('token'), '_blank');
    }

    showHappyBirthdayDialog() {
        this.displayHappyBirthDayDialog = true;
    }

    hideHappyBirthdayDialog(event) {
        this.displayHappyBirthDayDialog = false;
    }

    showPopUpDialog() {
        this.popupDialog = true;
    }

    hidePopUpDialog(event) {
        this.popupDialog = false;
    }

    public getAccount() {
        if ( this.loginService.loggedIn() ) {
            const profile = JSON.parse(localStorage.getItem('profile'));
            this.ImgPerfile = JSON.parse(localStorage.getItem('profile')).avatar;
            this.currentLang = profile.language;

            this.translate.setDefaultLang(this.currentLang);
            this.translate.use(this.currentLang);
            // this.changeLanguage(this.currentLang);

            if (profile.employee) {
                if (profile.employee.date_birth) {
                    const dateBirth = new Date(profile.employee.date_birth);
                    const today = new Date();

                    const dB = dateBirth.getDate() + ' ' + dateBirth.getMonth();

                    if (dateBirth.getDate() + ' ' + dateBirth.getMonth() === today.getDate() + ' ' + today.getMonth()) {
                        this.displayHappyBirthDayDialog = true;
                        this.happyBirthday = true;
                        this.happyBirthdayUsername = profile.employee.name;
                        this.happyBirthdayTitle = 'Happy Birthday';
                        this.happyBirthdayMessage = 'Te desea toda tu familia de Redes Humanas';
                    }
                }
                this.popupDialog = true;
            }
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public getPopupValidationByRole() {
        var validationStatus: boolean = false;

        if (this.role_id != 59 && this.role_id != 62 && this.role_id != 73 && this.role_id != 76)
            validationStatus = true;
        else 
            validationStatus = false;

        return validationStatus;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baPageTop/baPageTop.component.ts